import Modal from "./modal";
import $ from 'jquery';

export default class StaticModal extends Modal {

    constructor(targetSelector) {
        super();
        this.targetSelector = targetSelector;
    }

    getContent() {
        let target = $(this.targetSelector);
        if (target.length === 0) {
            throw new Error('Modal target not found');
        }

        let content = target.children();
        return Promise.resolve(content);
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/js/static-modal.js